<template>
  <QTable
    v-model:pagination="pagination"
    :class="tableClass"
    :columns="columns"
    hide-bottom
    row-key="filename"
    :rows="files"
  >
    <template #header>
      <QTr>
        <QTh>File Name</QTh>
        <QTh v-if="!hideDescription"> Description </QTh>
        <QTh
          v-if="!hideUpload"
          class="text-right"
        >
          <slot name="uploadButton" />
          <QBtn
            class="q-px-xs"
            color="primary"
            dense
            :disable="disable"
            icon="attach_file"
            :label="submitButtonText"
            no-caps
            size="sm"
            @click="$emit('show-upload-modal')"
          />
        </QTh>
      </QTr>
    </template>

    <template #body="props">
      <QTr :props="props">
        <QTd
          key="filename"
          :props="props"
        >
          <div v-if="props.row.url">
            <a
              :href="props.row.url"
              rel="noopener noreferrer"
              target="_blank"
            >
              {{ displayFileName(props.row) }}
            </a>
          </div>
          <div v-else>
            <div class="row">
              {{ displayFileName(props.row) }}
              <div class="q-ml-xs text-ds-red-5">(Uploaded upon save)</div>
            </div>
          </div>
        </QTd>
        <QTd
          v-if="!hideDescription"
          key="description"
          :props="props"
        >
          {{ props.row.description }}
        </QTd>
        <QTd
          v-if="!hideUpload"
          key="actions"
          :props="props"
        >
          <QBtn
            v-if="!hideDelete"
            class="q-px-sm q-ma-xs"
            dense
            :disable="disable"
            flat
            icon="delete_outline"
            @click="confirmDeleteFile(props.row)"
          />
        </QTd>
      </QTr>
    </template>
  </QTable>
</template>

<script>
export default {
  name: "UploadTable",
  props: {
    files: {
      type: Array,
      required: true,
    },
    submitButtonText: {
      type: String,
      default: "Upload File",
    },
    hideUpload: {
      type: Boolean,
    },
    hideDescription: {
      type: Boolean,
    },
    hideDelete: {
      type: Boolean,
    },
    disable: {
      type: Boolean,
    },
    tableClass: {
      type: String,
      default: "",
    },
  },
  emits: ["show-upload-modal", "delete"],
  data() {
    return {
      columns: [
        {
          name: "filename",
          required: true,
          label: "File Name",
          align: "left",
          field: "filename",
          style: "width: 45%",
          classes: "wrap-table-content",
        },
        {
          name: "description",
          required: true,
          label: "Description",
          align: "left",
          field: "description",
          style: "width: 45%",
          classes: "wrap-table-content",
        },
        {
          name: "actions",
          required: true,
          label: "Actions",
          align: "right",
          style: "width: 10%",
          classes: "wrap-table-content",
        },
      ],
      pagination: {
        rowsPerPage: 0,
      },
    };
  },
  methods: {
    confirmDeleteFile(file) {
      this.$q
        .dialog({
          title: "Confirm delete",
          message: `You are about to delete the file - ${file.filename}`,
          persistent: true,
          ok: "Delete file",
          cancel: "Cancel",
        })
        .onOk(() => {
          this.$emit("delete", file);
        });
    },
    displayFileName(file) {
      const { filename } = file;

      if (file.attachable && file.id) {
        return filename.substring(filename.indexOf("-") + 1).trim();
      }

      return filename;
    },
  },
};
</script>

<style lang="scss" scoped>
table .wrap-table-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: initial;
  word-wrap: break-word;
  overflow-wrap: break-word;
  font-size: 14px;
}
</style>
